import { CustomerV2Status } from 'types/customers'

export const statusVariantMap: Partial<Record<CustomerV2Status, 'success' | 'warning' | 'error'>> =
  {
    APPROVED: 'success',
    SUBMITTED: 'warning',
    IN_REVIEW: 'warning',
    REJECTED: 'error',
    NOT_STARTED: 'warning',
  }
